import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import {
  DataAssetConfiguraionComponent
} from './data-asset-configuraion.component';

import {
  ConfigureDataAssetByIdComponent
} from './configure-data-asset-by-id/configure-data-asset-by-id.component';

import { DataAssetConfigurationRouter } from './data-asset-configuration.router';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    DataAssetConfiguraionComponent,
    ConfigureDataAssetByIdComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SharedModule,
    DataAssetConfigurationRouter
  ]
})
export class DataAssetConfigurationModule {}